
import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, DocumentReference } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map, take  } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { Terminal, DeviceThing, TerminalRelay, TerminalDeviceDss } from '../../interfaces/terminal';

@Injectable({
  providedIn: 'root'
})
export class TerminalsService {

  private terminalsCollection: AngularFirestoreCollection<Terminal>;
  private terminals: Observable<Terminal[]>;
  public terminalsData: Terminal[];

  constructor(private afs: AngularFirestore, private auth: AuthService) {
    this.terminalsCollection = this.afs.collection<Terminal>('terminals');
    this.terminals = this.terminalsCollection.snapshotChanges().pipe(
      map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as Terminal;
          const id = a.payload.doc.id;
          return { id, ...data };
        });
      })
    );
  }

  getTerminals(): Observable<Terminal[]> {
    // console.log(this.terminalsCollection);

    //console.log(this.terminals);
    return this.terminals;
  }

  getTerminal(id: string): Observable<Terminal> {
    return this.terminalsCollection.doc<Terminal>(id).valueChanges();
  }


  filterTerminals(filter: string): Observable<Terminal[]> {
    filter = filter.toLowerCase();
    if (filter.length === 0) {
      return this.terminals;
    }
    const strFrontCode = filter.slice(0, filter.length - 1);
    const strEndCode = filter.slice(filter.length - 1, filter.length);

    const startCode = filter;
    const endCode = strFrontCode + String.fromCharCode(strEndCode.charCodeAt(0) + 1);

    // return this.installationsCollection.ref.where('name', '>=', startCode).where('name', '<', endCode).get();

    return this.terminals.pipe(
      map(items =>  items.filter(item =>
        (item.name.toLowerCase() >= startCode && item.name.toLowerCase() <= endCode) || item.name.toLowerCase().includes(filter)
      ))
    );
  }

  addTerminal(terminal: Terminal) {
    terminal.id = this.afs.createId();
    return this.terminalsCollection.doc(terminal.id).set(terminal);
  }

  updateTerminal(terminal: Terminal, device?: DeviceThing): Promise<void>  {
    // console.log(device);
    // console.log(terminal);
    if (device !== null ) {
      terminal.deviceRef = this.afs.firestore.collection('devices').doc('box').collection('things').doc(device.id);
    }
    return this.terminalsCollection.doc(terminal.id).update(terminal);
  }

  openRelayTerminal( terminal: Terminal, id: string) {
    terminal.config.relays.forEach( fRelay => {
      if (fRelay.id === id) {
        fRelay.open = true;
      }
    });
    // console.log(terminal);
    return this.terminalsCollection.doc(terminal.id).update(terminal);
  }

  forcedRelayTerminal( terminal: Terminal, id: string, forced: boolean) {
    terminal.config.relays.forEach( fRelay => {
      if (fRelay.id === id) {
        fRelay.forced = forced;
      }
    });
    return this.terminalsCollection.doc(terminal.id).update(terminal);
  }

  getAreasIDTerminals(areaDocId: string): Observable<Terminal[]> {
    const areaDocRef = this.afs.firestore.collection('areas').doc(areaDocId);
    // console.log(areaDocRef);
    return this.afs.collection<Terminal>('terminals',
    (ref) => {
      return ref.where('areaRef', '==', areaDocRef);
    }).valueChanges();
  }

  getTerminalsDss(): Observable<Terminal[]> {
    return this.afs.collection<Terminal>('terminals',
    (ref) => {
      return ref.where('status.ref', '!=', null)
      .where('status.ref', '>', '     ');
    }).valueChanges();
  }

  getTerminalsDssByServer(): Observable<TerminalDeviceDss[]> {
    return this.afs.collection('devices').doc('dss').collection<TerminalDeviceDss>('terminals').valueChanges();
  }
}
